import { render, staticRenderFns } from "./MultiStbl.vue?vue&type=template&id=0c4ffb56&scoped=true"
import script from "./MultiStbl.vue?vue&type=script&lang=js"
export * from "./MultiStbl.vue?vue&type=script&lang=js"
import style0 from "./MultiStbl.vue?vue&type=style&index=0&id=0c4ffb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ffb56",
  null
  
)

export default component.exports